<template>
    <div v-if="showModal && voucherx">
        test
        <b-modal
            v-model="showModalLocal"
            :title="'Установить необходимое действие'"
            class="modal-primary"
            size="md"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >
            <form  @submit.prevent="handleOk">

                <b-form-group label="Время выполнения" description="время, когда необходимо выполнить действие">
                    <date-picker
                        v-model="dtime"
                        :config="config"
                        :attributes="datepicker_attributes"
                    >
                        <b-form-input
                            type="text"
                            id="date_begin_iso_input"
                            slot-scope="{ inputProps, inputEvents, isDragging }"
                            class="form-control form-date-picker"
                            readonly
                            :state="validateState('date_begin_iso')"
                            v-bind="inputProps"
                            v-on="inputEvents" />
                    </date-picker>
                </b-form-group>

                <b-form-group label="Необходимое действие" description="краткое (до 100 символов) название действия">
                    <b-form-input type="text"
                                  v-model="text"
                                  v-validate="{max:100,required:true}"
                                  id="status_action_info"
                                  name="status_action_info"
                                  data-vv-as="'Необходимое действие'"
                                  :state="validateState('status_action_info')"
                                  aria-describedby="status_action_info_feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="status_action_info_feedback"> {{ veeErrors.first('status_action_info') }}</b-form-invalid-feedback>
                </b-form-group>

            </form>


            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Сохранить
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    export default {
        name: 'StatusDialog',
        components: {
            datePicker,
        },
        mixins: [functions],
        data: function () {
            return {
                config:{
                    format: 'DD.MM.YYYY HH:mm',
                    locale: 'ru',
                    stepping:15
                },
            };
        },
        model: {
            prop: "showModal",
            event: "hide",
            _text: null,
            _dtime:null
        },
        props: {
            showModal: [Number, Boolean],
            voucherx: Object,
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                this.$emit("hide", false);
            },
            handleOk: function () {
                /* дата возвращаемая элементом управления - строка 'DD.MM.YYYY HH:mm', переводим ее во внутренний формат */
                let momentDate = moment(this._dtime, 'DD.MM.YYYY HH:mm');
                this.voucherx.close_status_at = momentDate.toDate();
                this.voucherx.status_action_info = this._text;
                this.$emit("changed", false);
                this.$emit("hide", false);
            },
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return this.showModal
                },
                set: function (newValue) {}
            },
            text: {
                set: function(val) {
                    this._text = val;
                },
                get: function () {
                    if (!this._text) {
                        this._text = this.voucherx.status_action_info;
                    }
                    return this._text;
                }
            },
            dtime: {
                set: function(val) {
                    this._dtime = val;
                },
                get: function () {
                    if (!this._dtime) {
                        this._dtime = this.voucherx.close_status_at;
                    }
                    return this._dtime;
                }
            }
        },
        created: function() {
            //console.log('SimpleDialog: created');
        },
        mounted: function() {
            //console.log('SimpleDialog: mounted');
        },
        updated: function() {
            //console.log('SimpleDialog: updated');
        },
    }
</script>
